import { Controller } from "@hotwired/stimulus"

// Truncates a section description to one line and reveals a "more" link that expands the full text
// in place; the link then reads "Hide" and re-collapses it back to the single truncated line. On
// connect, hides the link when the text isn't actually truncated (fits on one line).
export default class extends Controller {
  static targets = ["text", "more"]

  connect() {
    if (!this.hasTextTarget || !this.hasMoreTarget) return
    // A restored Turbo snapshot can carry the expanded classes/label, so collapse before measuring.
    this.collapse()
    this.moreTarget.classList.remove("hidden")
    const el = this.textTarget
    // line-clamp-1 caps clientHeight at one line; a taller scrollHeight means it's truncated.
    if (el.scrollHeight <= el.clientHeight + 1) {
      this.moreTarget.classList.add("hidden")
    }
  }

  toggle(event) {
    event.preventDefault()
    if (this.expanded) this.collapse()
    else this.expand()
  }

  expand() {
    this.setExpanded(true)
  }

  collapse() {
    this.setExpanded(false)
  }

  setExpanded(expanded) {
    this.expanded = expanded
    this.textTarget.classList.toggle("line-clamp-1", !expanded)
    this.textTarget.classList.toggle("whitespace-pre-line", expanded)
    this.element.classList.toggle("items-baseline", !expanded)
    this.element.classList.toggle("flex-col", expanded)
    this.element.classList.toggle("items-center", expanded)
    this.moreTarget.textContent = expanded ? "Hide" : "more"
    this.moreTarget.setAttribute("aria-expanded", expanded ? "true" : "false")
  }
}
